import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    EntityCacheDispatcher,
    EntityCollectionServiceElementsFactory,
    HttpUrlGenerator,
    Logger,
    QueryParams
} from '@ngrx/data';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { WebsocketBrokerService } from '../../../core/services/websocket-broker.service';
import { WebSocketEntityCollectionServiceBase } from '../../../state/entity/web-socket-entity-collection-service-base';

import { DateAppointmentService } from '../../appointments/state/date-appointment.service';
import { PatientAppointmentService } from '../../patients/state/patient-appointment.service';
import { AppointmentListEntityDataServiceBase } from './appointment-list-entity-data-service.base';
import { appointmentListEntityMetadata, AppointmentListQueryFilter } from './appointment-list.entity';
import { AppointmentListSelectors } from './appointment-list.selectors';

@Injectable()
export class AppointmentListService extends WebSocketEntityCollectionServiceBase<any> {

    queryFilter$: Observable<AppointmentListQueryFilter>;
    refreshing$: Observable<boolean>;

    constructor(private http: HttpClient,
                private serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super(appointmentListEntityMetadata.entityName, serviceElementsFactory);

        this.queryFilter$ = this.selectors$['queryFilter$'];
        this.refreshing$ = this.selectors$['refreshing$'];
    }

    getAppointmentState(userId: number): Observable<any> {
        return this.http
            .get<{ locations: Array<String> }>(`servlets/appointments/appointmentstates/?userid=${userId}`, {observe: 'body'})
            .pipe(
                map((response: any) => response.appointmentStates)
            );
    }

    getLogEvent(appointmentId: number): Observable<Array<any>> {
        return this.http
            .get<{ logEvents: any }>(`servlets/appointments/${appointmentId}/logevents/`, { observe: 'body' })
            .pipe(
                map((response: any) => response.logEvents)
            );
    }

    getXMLLog(uuid: String): Observable<any> {
        return this.http
            .get(`servlets/autoremind/xml/${uuid}/log/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.appointmentXmlLog)
            );
    }

    getAppointmentSettings(userId: number): Observable<any> {
        return this.http
            .get(`servlets/appointments/user/appointmentlistsettings/?userid=${userId}`, {observe: 'body'})
            .pipe(
                map((response: any) => response.appointment)
            );
    }

    saveAppointmentSettings(displayTwoway: boolean, displayBirthday: boolean, displayIncorrectDestinator: boolean, showProviders: boolean): Observable<any> {
        return this.http
            .put('servlets/appointments/user/appointmentlistsettings/', {displayTwoway, displayBirthday, displayIncorrectDestinator, showProviders})
            .pipe(
                map((response: any) => response.appointment)
            );
    }
}

/**
 * This is the data service NgRx Data will use to call from effects to make the actual calls to the backend.
 */
@Injectable()
export class AppointmentListEntityDataService extends AppointmentListEntityDataServiceBase<any> {
    constructor(http: HttpClient,
                httpUrlGenerator: HttpUrlGenerator,
                logger: Logger,
                public entityCacheDispatcher: EntityCacheDispatcher,
                public websocketBrokerService: WebsocketBrokerService,
                public dateAppointmentService: DateAppointmentService,
                public patientAppointmentService: PatientAppointmentService,
                public appointmentsListSelectors: AppointmentListSelectors) {
        super(http, httpUrlGenerator, logger, entityCacheDispatcher, websocketBrokerService, dateAppointmentService,
            patientAppointmentService, 'AppointmentList', 'appointment-list-twoway-unread/', appointmentsListSelectors);
        logger.log('Created custom Appointment List Two way unread EntityDataService');
    }

    subscribeWebSocketJob(parameters: any | QueryParams): void {
        this.subscribeWebSocketJobWithBody({parameters});
    }

    refreshWebSocketJob(parameters: any | QueryParams): void {
        this.refreshWebSocketJobWithBody({parameters});
    }
}
